import React from 'react';
import PropTypes from 'prop-types';
import { formatDate } from '../../utils/date';
import RaceCardLink from '../../shared/links/RaceCardLink';

const UpcomingRaceCell = ({ upcomingRace }) => (
    <RaceCardLink {...upcomingRace} >
        {formatDate(upcomingRace.raceDatetime, 'h:mm')}
    </RaceCardLink>
);

UpcomingRaceCell.propTypes = {
    upcomingRace: PropTypes.shape({
        raceDatetime: PropTypes.string,
    }),
};

export default UpcomingRaceCell;



// WEBPACK FOOTER //
// ./src/js/course/signposts/UpcomingRaceCell.jsx